import { styled } from '@mui/material/styles';
import MapViewportAnimation from './viewport-animation';

const StyledMapContainer = styled('div')(({ theme }) => ({
  zIndex: 0,
  height: '100%',
  overflow: 'hidden',
  position: 'relative',
  borderTopRightRadius: theme.shape.borderRadius,
  borderBottomRightRadius: theme.shape.borderRadius,
  // borderRadius: theme.shape.borderRadius,
  '& .mapboxgl-ctrl-logo, .mapboxgl-ctrl-bottom-right': {
    display: 'none'
  }
}));

export default function NewGeoMap() {
  return (
    <StyledMapContainer>
      <MapViewportAnimation
        mapboxAccessToken="pk.eyJ1Ijoib3BlbnJiZiIsImEiOiJwbnVZcVdzIn0.5jphOJEeoecHn8HlpwWN3g"
        mapStyle="mapbox://styles/openrbf/ckvnu7y7x0s3d14pdop83f5py"
      />
    </StyledMapContainer>
  );
}
